import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UnidPlanPdfNotAvailable from 'src/pages/scheduleSurgery/components/surgery/notifications/UnidPlanPdfNotAvailable';
import {
    UnIdNumber,
    UnId,
    UnIdConainter,
    Status,
    NormalDiv,
    RegularText,
    DemiText,
    EmptyDiv,
} from './UnidItem.styled';
import { getUnidUrl, deleteUnidUrl } from 'src/pages/orders/redux/actions';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const delimiter = '*#*';

const UnidItem = (props) => {
    const {
        planStatus,
        uniDId,
        isShowStatus,
        isMobileView,
        marginLeft,
        fromOrderPage,
        fromCalendarPage,
        week,
        textOverflow,
        overflow,
        width,
        showPlan,
    } = props;
    const [pdfNotAvailable, setPdfNotAvailable] = useState(false);
    const [toggleUnidHandler, setToggleUnidHandler] = useState(false);

    const dispatch = useDispatch();

    const { unidUrl } = useSelector((state) => state.unidUrlReducer);
    const { t } = useTranslation();
    const unID = t('common.unidLabel');
    useEffectWithErrorLogging(() => {
        if (toggleUnidHandler) {
            if (unidUrl === '' || unidUrl === undefined) {
                setPdfNotAvailable(true);
            } else {
                const urls = unidUrl.split(delimiter).filter((url) => url);
                urls.forEach((url) => {
                    window.open(url);
                });
            }
            setToggleUnidHandler(false);
            dispatch(deleteUnidUrl());
        }
    }, [unidUrl]);

    const openUNIDLinks = () => {
        setToggleUnidHandler(true);
        dispatch(getUnidUrl(uniDId));
    };
    return (
        <React.Fragment>
            {isMobileView ? (
                uniDId ? (
                    <NormalDiv>
                        <RegularText color="#4F4F4F" fontSize="12px">
                            {unID}
                        </RegularText>
                        <NormalDiv onClick={(e) => e.stopPropagation()}>
                            {planStatus === 'Approved' ||
                            planStatus === 'Plan Only' ||
                            showPlan ? (
                                <DemiText
                                    color="#1010EB"
                                    fontSize="12px"
                                    margin="0 2px 0 2px"
                                    onClick={openUNIDLinks}
                                    cursor={'pointer'}
                                >
                                    {uniDId}
                                </DemiText>
                            ) : (
                                <DemiText
                                    color="#140F4B"
                                    fontSize="12px"
                                    margin="0 2px 0 2px"
                                >
                                    {uniDId}
                                </DemiText>
                            )}
                            {isShowStatus && planStatus && (
                                <>
                                    |
                                    <RegularText
                                        color="#140F4B"
                                        fontSize="12px"
                                        margin="0 0 0 2px"
                                    >
                                        {fromOrderPage || fromCalendarPage ? (
                                            <>
                                                {showPlan
                                                    ? planStatus
                                                    : `Plan - ${planStatus}`}
                                            </>
                                        ) : (
                                            { planStatus }
                                        )}
                                    </RegularText>
                                </>
                            )}
                            {pdfNotAvailable && (
                                <UnidPlanPdfNotAvailable
                                    onClose={() => setPdfNotAvailable(false)}
                                />
                            )}
                        </NormalDiv>
                    </NormalDiv>
                ) : (
                    <NormalDiv height="22px"></NormalDiv>
                )
            ) : week ? (
                <UnIdConainter
                    marginLeft={marginLeft}
                    style={{ flexDirection: 'column' }}
                >
                    <div style={{ display: 'flex' }}>
                        <UnId> {unID}</UnId>
                        {planStatus &&
                        (planStatus === 'Approved' ||
                            planStatus === 'Plan Only' ||
                            showPlan) ? (
                            <>
                                <UnIdNumber
                                    onClick={openUNIDLinks}
                                    cursor={'pointer'}
                                    height="auto"
                                >
                                    {uniDId}
                                </UnIdNumber>
                                {planStatus && (
                                    <div style={{ fontSize: '12px' }}>|</div>
                                )}
                            </>
                        ) : (
                            <>
                                <UnIdNumber
                                    fontFamily={'AvenirNextWorld Regular'}
                                    color={'unset'}
                                >
                                    {uniDId}
                                </UnIdNumber>
                                {planStatus && (
                                    <div style={{ fontSize: '12px' }}>|</div>
                                )}
                            </>
                        )}
                    </div>
                    {planStatus ? (
                        <Status>
                            {showPlan ? planStatus : `Plan - ${planStatus}`}
                        </Status>
                    ) : (
                        <EmptyDiv></EmptyDiv>
                    )}
                    {pdfNotAvailable && (
                        <UnidPlanPdfNotAvailable
                            onClose={() => setPdfNotAvailable(false)}
                        />
                    )}
                </UnIdConainter>
            ) : (
                <UnIdConainter marginLeft={marginLeft} width={width}>
                    <UnId> {unID}</UnId>
                    {planStatus &&
                    (planStatus === 'Approved' ||
                        planStatus === 'Plan Only' ||
                        showPlan) ? (
                        <UnIdNumber
                            textOverflow={textOverflow}
                            overflow={overflow}
                            onClick={openUNIDLinks}
                            cursor={'pointer'}
                        >
                            {uniDId}
                        </UnIdNumber>
                    ) : (
                        <UnIdNumber
                            fontFamily={'AvenirNextWorld Regular'}
                            color={'unset'}
                            textOverflow={textOverflow}
                            overflow={overflow}
                        >
                            {uniDId}
                        </UnIdNumber>
                    )}
                    {isShowStatus && planStatus && (
                        <Status textOverflow={textOverflow} overflow={overflow}>
                            <div>|</div>
                            <div
                                style={{
                                    paddingLeft: '5px',
                                }}
                            >
                                {showPlan ? planStatus : `Plan - ${planStatus}`}
                            </div>
                        </Status>
                    )}
                    {pdfNotAvailable && (
                        <UnidPlanPdfNotAvailable
                            onClose={() => setPdfNotAvailable(false)}
                        />
                    )}
                </UnIdConainter>
            )}
        </React.Fragment>
    );
};

export default UnidItem;
